import { useCallback, useEffect, useState } from 'react';

interface WindowDimension {
  width: number;
  height: number;
}

export const useWindowDimension = (): WindowDimension => {
  const getSize = useCallback(
    () => ({
      width: window.innerWidth,
      height: window.innerHeight,
    }),
    [],
  );
  const [windowDimension, setWindowDimension] = useState(getSize);

  useEffect(() => {
    const handleResize = () => {
      setWindowDimension(getSize);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [getSize]);
  return windowDimension;
};
